import {PEV} from "../../../common/utils";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import * as service from "./service";

export const allPoliciesTab = {id: "allPolicies", name: "Policies"};
export const allPoliciesTable = {id: "allPoliciesTable"};

const initialState = {
    policyList: PEV({
        data: [],
        totalCount: 0,
    }),
};

const getPolicyList = createAsyncThunk("policyList/fetch",
    async (param: {
        page: number,
        size: number,
        userQuery: {
            name: string,
            id: string,
            group: string,
            scope: string,
            actions: string[],
            systemResource: any
        },
        sorter: string
    }) => {
        return await service.fetchPolicyList(param.page, param.size, param.userQuery, param.sorter);
    });

const PolicyListSlice = createSlice({
    name: "policyList",
    initialState,
    reducers: {
        resetPoliciesList(state) {
            state.policyList = initialState.policyList;
        },
    },
    extraReducers: {
        [getPolicyList.pending.type]: (state) => {
            // @ts-ignore
            state.policyList = PEV({...initialState.policyList.value}, "Fetching policies");
        },
        [getPolicyList.fulfilled.type]: (state, action) => {
            state.policyList = PEV({
                data: action.payload.dataSource,
                totalCount: action.payload.totalCount,
            });
        },
        [getPolicyList.rejected.type]: (state) => {
            // @ts-ignore
            state.policyList = PEV({...initialState.policyList.value}, null, "Error while fetching policies");
        },
    },
});

export const PolicyListReducer = PolicyListSlice.reducer;
const {resetPoliciesList} = PolicyListSlice.actions;
export const PolicyListActions = {getPolicyList, resetPoliciesList};